import { AbstractControl } from "@angular/forms";
import * as moment from "moment-timezone";

export class HelperFunctions {
  static passwordMatcher(c: AbstractControl): { [key: string]: boolean } | null {
    const password: any = c.get('newPassword');
    const confirmpassword: any = c.get('confirmNewPassword');
    if (password.pristine || confirmpassword.pristine) {
      return null;
    }
    if (password.value === confirmpassword.value) {
      return null;
    }
    return { 'match': true };
  }

  static compareFirstLoginDate(firstLoginDate: string,currentDate: string): boolean {
    const loginDate = moment(Date.parse(firstLoginDate)).format("YYYY-MM-DDThh:mm");
    const currentLoginDate: Date | string = moment(Date.parse(currentDate)).format("YYYY-MM-DDThh:mm");
    return loginDate == currentLoginDate ? true : false;
  }

  static isIE(): boolean {
    const userAgent = window.navigator.userAgent;

    if (userAgent.indexOf("MSIE") > 0) {
      return true;
    }

    if (userAgent.indexOf("Trident/") > 0) {
      return true;
    }

    if (userAgent.indexOf("Edge/") > 0) {
      return true;
    }
    return false;
  }

  static containsSubstringInList(substringToCheck: string, substringLengthToCheck: number, stringsToCheck: string[]): boolean {
    return stringsToCheck.some(str => {
      if (str && str.trim() !== "") {
        for (let i = 0; i <= substringToCheck.length - substringLengthToCheck; i++) {
          const groupedCharsToCheck = substringToCheck.slice(i, i + substringLengthToCheck);
          if (str.toLowerCase().includes(groupedCharsToCheck.toLowerCase())) {
            return true;
          }
        }
      }
      return false;
    });
  }

    //Check if array or string is empty or undefined
    static IsEmptyOrUndefined(valueToCheck: any): boolean {
      return valueToCheck === 'undefined' || valueToCheck === undefined || valueToCheck === null || valueToCheck === '' || (Array.isArray(valueToCheck) && valueToCheck.length == 0);
    }
  static buildSearchParamsString(searchString:string, pageNumber: number , pageSize:number ): string {
    let searchParams: string = '?';

    if (!HelperFunctions.IsEmptyOrUndefined(pageNumber)) {
      searchParams = searchParams + (searchParams == '?' ? 'currentPage=' : '&currentPage=') + pageNumber;
    }

    if (!HelperFunctions.IsEmptyOrUndefined(searchString)) {
      searchParams = searchParams + (searchParams == '?' ? 'searchValue=' : '&searchValue=') + searchString;
    }

    if (!HelperFunctions.IsEmptyOrUndefined(pageSize)) {
      searchParams = searchParams + (searchParams == '?' ? 'pageSize=' : '&pageSize=') + pageSize;
    }
    return searchParams;
  }
}
